import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'INBOX_MAIN';

export const {action: selectConversation} = createAction(
    `${domain}/SELECT_CONVERSATION`,
    (conversationId: string, messagesToForward?: string[]) => ({
        conversationId,
        messagesToForward,
    }),
);

export const {action: reset} = createAction(`${domain}/RESET`, () => ({}));

export const {action: clearMessagesToForward} = createAction(`${domain}/CLEAR_MESSAGES_TO_FORWARD`, () => ({}));
